import React, {FC} from 'react';

import CookiesContext from './cookiesContext';
import {CookiesManager} from './cookiesManager';

/**
 * Cookies context provider
 * @param {CookiesManager} manager - cookie manager
 * @param {React.Component} children - children
 * @return {React.Component} component wrapped by the provider
 */
export const CookiesProvider: FC<{manager: CookiesManager}> = ({
    manager = new CookiesManager(),
    children,
}) => {
    return <CookiesContext.Provider value={manager}>{children}</CookiesContext.Provider>;
};
